import { DocumentVersion } from "@models";
import { DifferenceOutlined } from "@mui/icons-material";
import GenericButton from "src/components/GenericButton/GenericButton";

export const DiffButton = ({
  selectedVersion,
  onToggleDiff,
  isDiffMode,
  isDraft = false,
}: {
  selectedVersion: DocumentVersion | undefined;
  onToggleDiff?: () => void;
  isDiffMode: boolean;
  isDraft?: boolean;
}) => {
  if (!selectedVersion) {
    return null;
  }

  const disabled = isDraft || !onToggleDiff;

  const diffModeButtonProps = {
    startIcon: <DifferenceOutlined fontSize="small" />,
    text: "Hide Changes",
  };

  return (
    <GenericButton
      onClick={onToggleDiff ?? (() => {})}
      tooltipContent={
        isDraft
          ? "Generate the document to see redlines"
          : disabled
          ? "Changes document not available on this version."
          : "Show Changes Document"
      }
      hideTooltip={isDiffMode}
      textColor="rgba(0, 0, 0, 0.54)"
      variant="contained"
      {...(isDiffMode && diffModeButtonProps)}
      size="small"
      isDisabled={disabled}
    >
      {!isDiffMode && <DifferenceOutlined fontSize="small" />}
    </GenericButton>
  );
};

export default DiffButton;
